import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { COMPARE_OLD, COMPARE_NEW } from './salesData';
export function CoverageSection() {
  return <section id="diferencia" className="bg-sand py-14 sm:py-20" data-id="element-81" data-mp="1n1fxvvlyy73t">
      <div className="mx-auto max-w-4xl px-5" data-id="element-82" data-mp="1n4bv1hpzsrr7">
        <div className="text-center" data-id="element-83" data-mp="1r3t56ogd6d2p">
          <SectionTag className="bg-white" data-id="element-84" data-mp="1r2rtchrixmjx">La diferencia</SectionTag>
          <h2 className="mx-auto mt-4 max-w-[18ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[26ch] sm:text-[2.4rem]" data-id="element-85" data-mp="uebws1pzycxb">
            No gana quien tiene más recetas.
            <span className="block text-gold" data-id="element-86" data-mp="13cfc2gae2dgo">Gana quien consigue empezar.</span>
          </h2>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-87" data-mp="18ecwveyftgbq">
          <div className="rounded-3xl border border-stone bg-white/70 p-6" data-id="element-88" data-mp="2etx80tlqa8sn">
            <h3 className="font-display text-[0.7rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-89" data-mp="2jrynz5nuxrzw">
              Mega pack tradicional
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-90" data-mp="w23aahqn1bzc">
              {COMPARE_OLD.map(item => <li key={item} className="flex gap-3 font-sans text-[0.9rem] leading-snug text-taupe" data-id="element-91" data-mp="r4b90x43sdih">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-taupe/50" aria-hidden strokeWidth={3} data-id="element-92" data-mp="m2uah893d352" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-gold bg-white p-6 shadow-[0_22px_50px_-30px_rgba(232,62,115,0.7)]" data-id="element-93" data-mp="d5bl5rof02nd">
            <h3 className="font-display text-[0.7rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-94" data-mp="8bfocsjw0lts">
              Postres que Venden™
            </h3>
            <ul className="mt-5 space-y-3" data-id="element-95" data-mp="3ultdqvokx4eo">
              {COMPARE_NEW.map(item => <li key={item} className="flex gap-3 font-sans text-[0.92rem] font-semibold leading-snug text-charcoal" data-id="element-96" data-mp="3pkcjvk4iii7l">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-97" data-mp="3ay70quk9ild4" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}